export default "__VITE_ASSET__DHsV$rq8__"